import { usePermissions } from 'shared/hooks';
import { useAuthState } from 'shared/stores';

export function useUserPermissions() {
  const authState = useAuthState();
  const user = authState.user.get();
  const claims = user?.insightClaims || '';
  const { permissions } = usePermissions(claims);
  return permissions;
}
